import { connect } from 'react-redux';
import Controller from '../modules/index';
import {
  getAccessoryVariantData,
  getAllAccessoryTypeDataOnTabClick,
  getCurrentPartsConfigFromFlatConfig
} from './customizer.duck';

const mapStateToProps = ({ customizer }) => ({
  isDataReady: customizer.isDataReady
});

const mapDispatchToProps = dispatch => ({
  getAccessoryVariantData: variantId => {
    dispatch(getAccessoryVariantData(variantId));
  },
  getAllAccessoryTypeDataOnTabClick: accessoryVariant => {
    dispatch(getAllAccessoryTypeDataOnTabClick(accessoryVariant));
  },
  getCurrentPartsConfigFromFlatConfig: savedConfig => {
    dispatch(getCurrentPartsConfigFromFlatConfig(savedConfig));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Controller);
